const en = {
  errorMessageTitle: "Refresh the page",
  errorMessageText: "Failed to load the page. Try refreshing it. If the error occurs again, try waiting a few minutes and try again.",
  reloadPage: "Refresh the page",
} as const;

export default en;
